import PropTypes from 'prop-types'
import React from 'react'

import EmailButton from './EmailButton'


const MemberEmailButton = ({member, emailSubjectTpl, emailBodyTpl}) => {
  if (!member || !emailSubjectTpl || !emailBodyTpl) {
    return false
  }

  const subject = emailSubjectTpl(member)
  const body = emailBodyTpl(member)

  return <EmailButton recipient={member.email} subject={subject} body={body} />
}

MemberEmailButton.propTypes = {
  member: PropTypes.object,
  emailSubjectTpl: PropTypes.func,
  emailBodyTpl: PropTypes.func
}

export default MemberEmailButton



// WEBPACK FOOTER //
// ./src/MemberEmailButton.js